<div class="card-data mx-3 mx-md-5  ">
  <form [formGroup]="paymentForm">
    <h3 class="text-center">
      {{ "Payment" | translate }}
    </h3>
    <!-- Display Product -->
    <div class="row text-center" *ngIf="product">
      <div>
        <small>{{ product.name }}</small>
      </div>
      <div>
        <small [ngClass]="promotionDiscount > 0 ? 'price-discounted' : ''">{{ price }} L.E</small>
        <small *ngIf="promotionDiscount > 0" class="ms-3 text-success fw-bold">{{ paymentRequest.amount }} L.E</small>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <label>{{ "First Name" | translate }}*</label>
        <input type="text" placeholder="{{ 'Enter your first name' | translate }}" formControlName="firstName" />
        <div *ngIf="
            paymentForm.get('firstName')?.invalid &&
            paymentForm.get('firstName')?.touched
          " class="text-danger">
          <small *ngIf="paymentForm.get('firstName')?.errors?.['required']">
            {{ "First name is required" | translate }}
          </small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Last Name" | translate }}*</label>
        <input type="text" formControlName="lastName" placeholder="{{ 'Enter your last name' | translate }}" />
        <div *ngIf="
            paymentForm.get('lastName')?.touched &&
            paymentForm.get('lastName')?.errors
          " class="text-danger">
          <small *ngIf="paymentForm.get('lastName')?.errors?.['required']">
            {{ "Last name is required" | translate }}
          </small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Phone Number" | translate }}*</label>
        <input type="number" placeholder="{{ 'Enter your phone number' | translate }}" formControlName="phone" />
        <div *ngIf="
            paymentForm.get('phone')?.touched &&
            paymentForm.get('phone')?.errors
          " class="text-danger">
          <small *ngIf="paymentForm.get('phone')?.errors?.['required']">
            {{ "Phone number is required" | translate }}
          </small>
          <small *ngIf="paymentForm.get('phone')?.errors?.['pattern']">
            {{ "Invalid phone number format" | translate }}
          </small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Email" | translate }}*</label>
        <input type="email" placeholder="{{ 'Enter your email' | translate }}" formControlName="email" />
        <div *ngIf="
            paymentForm.get('email')?.touched &&
            paymentForm.get('email')?.errors
          " class="text-danger">
          <small *ngIf="paymentForm.get('email')?.errors?.['required']">
            {{ "Email is required" | translate }}
          </small>
          <small *ngIf="paymentForm.get('email')?.errors?.['email']">
            {{ "Invalid email format" | translate }}
          </small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <label>{{ "Promotion Code" | translate }}</label>
        <div class="promotion-wrapper">
          <div class="promotion-input-container">
            <input type="text" placeholder="{{ 'Enter promotion code' | translate }}" formControlName="promotion"
              [class.success-input]="isPromotionApplied" [readonly]="isPromotionApplied" />

            <!-- Apply button inside input -->
            <button *ngIf="!isPromotionApplied" type="button" class="apply-inline-btn" [disabled]="isLoadingPromotion"
              (click)="useCode()">
              <span *ngIf="!isLoadingPromotion">{{ "Apply" | translate }}</span>
              <span *ngIf="isLoadingPromotion">
                <i class="fa-solid fa-spinner fa-spin"></i>
              </span>
            </button>

            <!-- Success check icon -->
            <i *ngIf="isPromotionApplied" class="fa-solid fa-circle-check promotion-check-icon"></i>
          </div>

          <!-- Remove button stays below -->
          <div *ngIf="isPromotionApplied" class="mt-2">
            <button type="button" class="remove-promo-btn" (click)="removePromotion()">
              <i class="fa-solid fa-times"></i> {{ "Remove" | translate }}
            </button>
          </div>

          <div *ngIf="promotionError" class="text-danger mt-2">
            <small>{{ promotionError }}</small>
          </div>

          <div *ngIf="isPromotionApplied && !promotionError" class="text-success mt-2">
            <small>
              <i class="fa-solid fa-check-circle"></i>
              {{ "Promotion code applied successfully!" | translate }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center">
      <button type="submit" class="gradient-button mt-5" (click)="onSubmit()" [disabled]="!isFormValid()">
        {{ "Submit" | translate }}
      </button>
    </div>
  </form>
</div>